import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router';
import { getSubjectContent } from '../../services/learnService';
import { convertTime } from '../../utils/utils';

import { notification, Collapse, Modal } from 'antd';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Place from '../../assets/icons/Place';
import picture from '../../assets/images/instructor.svg';
import {
  Link as ScrollLink,
  animateScroll as scroll,
  Element,
} from 'react-scroll';
import Money from '../../assets/icons/Money';

import Footer from '../../components/Footer/Footer';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';
import { scrollToTop } from '../../utils/utils';

const SinglePaidCourse = () => {
  useEffect(() => {
    scrollToTop();
  }, []);

  const [content, setContent] = useState([]);
  const [school, setSchool] = useState({});

  const [activeTab, setActiveTab] = useState('about');
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [reference, setReference] = useState('');

  useEffect(() => {
    setReference(`PL-EDV${Date.now()}${Math.floor(Math.random() * 10 + 1)}`);
  }, []);

  const navigate = useNavigate();
  let str = useParams();
  let courseId = str?.id?.split('-').pop();

  let query = new URLSearchParams(useLocation().search);
  let schoolId = query.get('school');
  const { Panel } = Collapse;

  useEffect(() => {
    const getContent = async () => {
      try {
        setLoading(true);
        let res = await getSubjectContent(schoolId, courseId);
        setContent(res.data.course);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };

    getContent();
  }, []);

  useEffect(() => {
    const getSchool = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${baseURL}/schools/${schoolId}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer `,
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        const data = await res.json();

        if (res.status === 200) {
          setLoading(false);
          setSchool(data.data.school);
        }
        if (res.status === 401) {
          setLoading(false);
          notification['error']({
            message: 'Session expired, please log in again',
          });
          navigate('/login');
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    getSchool();
  }, []);

  const handleCancel = () => {
    setShowPreview(false);
  };

  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const d = new Date();
  let day = weekdays[d.getDay()];
  let hour = d.getHours();

  return (
    <>
      <DashboardHeader />
      {loading ? (
        <Spinner />
      ) : (
        <div className='subject-content-wrapper'>
          <div>
            <div
              className='single-subject__hero'
              style={{
                background: `linear-gradient( 
            rgba(54, 54, 165, 0.7) 100%, 
            rgba(54, 54, 165, 0.7)100%),url(${content?.banner})`,
              }}
              //style={{ backgroundImage: `url(${headerImg})` }}
            >
              <div className='single-subject__hero__breadcrumbs'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                    fill='white'
                  />
                </svg>
                <p>
                  {' '}
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate('/dashboard')}
                  >
                    Home
                  </span>{' '}
                  | {content?.subject_class?.title}
                </p>
              </div>
              <h3>{content?.subject_class?.title}</h3>
              <p style={{ marginTop: '18px', color: '#fff', fontSize: '24px' }}>
                Offered by: {school?.name}
              </p>
            </div>

            <div className='learn-tabs'>
              <ScrollLink to='about'>
                <p
                  className={
                    activeTab === 'about'
                      ? `learn-tabs__link active-learn-tab`
                      : `learn-tabs__link`
                  }
                  onClick={() => setActiveTab('about')}
                >
                  About This Subject
                </p>
              </ScrollLink>
              <ScrollLink to='features'>
                <p
                  className={
                    activeTab === 'features'
                      ? `learn-tabs__link active-learn-tab`
                      : `learn-tabs__link`
                  }
                  onClick={() => setActiveTab('features')}
                >
                  What you'll learn
                </p>
              </ScrollLink>
              <ScrollLink to='topics'>
                <p
                  className={
                    activeTab === 'topics'
                      ? `learn-tabs__link active-learn-tab`
                      : `learn-tabs__link`
                  }
                  onClick={() => setActiveTab('topics')}
                >
                  Subject Topics
                </p>
              </ScrollLink>
              <ScrollLink to='schedules'>
                <p
                  className={
                    activeTab === 'schedules'
                      ? `learn-tabs__link active-learn-tab`
                      : `learn-tabs__link`
                  }
                  onClick={() => setActiveTab('schedules')}
                >
                  Live Class Schedule
                </p>
              </ScrollLink>
              <ScrollLink to='instructor'>
                <p
                  className={
                    activeTab === 'instructor'
                      ? `learn-tabs__link active-learn-tab`
                      : `learn-tabs__link`
                  }
                  onClick={() => setActiveTab('instructor')}
                >
                  Instructor
                </p>
              </ScrollLink>
            </div>
            <div className='learn-flex'>
              <div className='learn-about'>
                <h3>About this subject</h3>
                <div className='learn-about__teaser'>
                  <div onClick={() => setShowPreview(true)}>
                    <video src={content.teaser} />
                  </div>

                  {/* <img src={teaser} alt=''  */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <p>
                      {content?.description ||
                        'No description available for this course'}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        className='play-icon-wrapper'
                        onClick={() => setShowPreview(true)}
                      >
                        <svg
                          width='11'
                          height='14'
                          viewBox='0 0 11 14'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M2 3.64L7.27 7L2 10.36V3.64ZM0 0V14L11 7L0 0Z'
                            fill='#323232'
                          />
                        </svg>
                      </div>
                      <p>Watch introductory video about this subject</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='content-details'>
                <div className='content-details__item'>
                  <div className='content-details__item__icon-wrapper'>
                    <svg
                      width='34'
                      height='34'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                        fill='#5A5955'
                      />
                    </svg>
                  </div>
                  <div className='content-details__item__text'>
                    <h3>Duration</h3>
                    <p>Estimated {content?.duration} to complete</p>
                  </div>
                </div>

                <div className='content-details__item'>
                  <div className='content-details__item__icon-wrapper'>
                    <svg
                      width='28'
                      height='28'
                      viewBox='0 0 28 28'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M14.0003 3.99984C15.8337 3.99984 17.3337 5.49984 17.3337 7.33317C17.3337 9.1665 15.8337 10.6665 14.0003 10.6665C12.167 10.6665 10.667 9.1665 10.667 7.33317C10.667 5.49984 12.167 3.99984 14.0003 3.99984ZM14.0003 20.6665C18.5003 20.6665 23.667 22.8165 24.0003 23.9998H4.00033C4.38366 22.7998 9.51699 20.6665 14.0003 20.6665ZM14.0003 0.666504C10.317 0.666504 7.33366 3.64984 7.33366 7.33317C7.33366 11.0165 10.317 13.9998 14.0003 13.9998C17.6837 13.9998 20.667 11.0165 20.667 7.33317C20.667 3.64984 17.6837 0.666504 14.0003 0.666504ZM14.0003 17.3332C9.55032 17.3332 0.666992 19.5665 0.666992 23.9998V27.3332H27.3337V23.9998C27.3337 19.5665 18.4503 17.3332 14.0003 17.3332Z'
                        fill='#5A5955'
                      />
                    </svg>
                  </div>
                  <div className='content-details__item__text'>
                    <h3>Lesson style</h3>
                    <p>{content?.lesson_style}</p>
                  </div>
                </div>

                <div className='content-details__item'>
                  <div className='content-details__item__icon-wrapper'>
                    <svg
                      width='40'
                      height='41'
                      viewBox='0 0 40 41'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g clipPath='url(#clip0_1750_8431)'>
                        <path
                          d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                          fill='#5A5955'
                        />
                        <path
                          d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                          fill='#5A5955'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_1750_8431'>
                          <rect width='40' height='40.9796' fill='white' />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className='content-details__item__text'>
                    <h3>Topics</h3>
                    <p>{content?.topics_count} Topics</p>
                  </div>
                </div>

                <div className='content-details__item'>
                  <div className='content-details__item__icon-wrapper'>
                    <svg
                      width='34'
                      height='34'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM28.533 10.3335H23.6163C23.083 8.25016 22.3163 6.25016 21.3163 4.40016C24.383 5.45016 26.933 7.5835 28.533 10.3335ZM16.9997 3.7335C18.383 5.7335 19.4663 7.95016 20.183 10.3335H13.8163C14.533 7.95016 15.6163 5.7335 16.9997 3.7335ZM4.09967 20.3335C3.83301 19.2668 3.66634 18.1502 3.66634 17.0002C3.66634 15.8502 3.83301 14.7335 4.09967 13.6668H9.73301C9.59967 14.7668 9.49967 15.8668 9.49967 17.0002C9.49967 18.1335 9.59967 19.2335 9.73301 20.3335H4.09967ZM5.46634 23.6668H10.383C10.9163 25.7502 11.683 27.7502 12.683 29.6002C9.61634 28.5502 7.06634 26.4335 5.46634 23.6668ZM10.383 10.3335H5.46634C7.06634 7.56683 9.61634 5.45016 12.683 4.40016C11.683 6.25016 10.9163 8.25016 10.383 10.3335ZM16.9997 30.2668C15.6163 28.2668 14.533 26.0502 13.8163 23.6668H20.183C19.4663 26.0502 18.383 28.2668 16.9997 30.2668ZM20.8997 20.3335H13.0997C12.9497 19.2335 12.833 18.1335 12.833 17.0002C12.833 15.8668 12.9497 14.7502 13.0997 13.6668H20.8997C21.0497 14.7502 21.1663 15.8668 21.1663 17.0002C21.1663 18.1335 21.0497 19.2335 20.8997 20.3335ZM21.3163 29.6002C22.3163 27.7502 23.083 25.7502 23.6163 23.6668H28.533C26.933 26.4168 24.383 28.5502 21.3163 29.6002ZM24.2663 20.3335C24.3997 19.2335 24.4997 18.1335 24.4997 17.0002C24.4997 15.8668 24.3997 14.7668 24.2663 13.6668H29.8997C30.1663 14.7335 30.333 15.8502 30.333 17.0002C30.333 18.1502 30.1663 19.2668 29.8997 20.3335H24.2663Z'
                        fill='#5A5955'
                      />
                    </svg>
                  </div>
                  <div className='content-details__item__text'>
                    <h3>Language</h3>
                    <p>{content?.language || 'English '}</p>
                  </div>
                </div>
              </div>
            </div>
            <Element name='features' smooth='true'>
              <div className='learn-about'>
                <h3>What you'll learn</h3>
                <div className='learn-about__what-you-will-learn'>
                  {content?.learning_outcomes?.map((el) => (
                    <div
                      className='learn-about__flex-item'
                      key={Math.random(1000)}
                    >
                      <div className='learn-about__flex-item__circle'>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                            fill='#161410'
                          />
                        </svg>
                      </div>
                      <p>{el.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Element>

            <Element name='topics' smooth='true'>
              <div className='learn-about'>
                <h3>Topics in {content?.subject_class?.title}</h3>
                <p>{content?.topics?.length || 0} topic(s) available</p>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  {content?.topics?.map((el, id) => (
                    <div className='topic-card'>
                      <img
                        src={
                          el.id === 27
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1697072867/06befdc8-89d2-47e6-a843-f87211ad214c_hub1lg.jpg'
                            : school?.id === 15
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1688428283/WhatsApp_Image_2023-06-08_at_12.26.34_iqqr4e.jpg'
                            : school?.id === 12
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680096219/WhatsApp_Image_2023-03-29_at_13.50.08_hqqdcv.jpg'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                ?.includes('biology')
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833246/4_ywa1uq.jpg'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                ?.includes('mathematics')
                            ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                ?.includes('english')
                            ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                .includes('food')
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680783147/food_and_nutrition_lqxah9.png'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                .includes('economics')
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833433/9_eknlh0.jpg'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                .includes('technical')
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833564/3_tzp8za.jpg'
                            : content?.subject_class?.title
                                ?.toLowerCase()
                                .includes('yoruba')
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1697073430/ce8719b2-2829-4e2d-b3c1-fe11763ee02b_idb5h9.jpg'
                            : el.id === 23
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1694164671/leadership-manaement_wzyksd.jpg'
                            : el.id === 26
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1694164672/practical_inclusion_haew6a.jpg'
                            : el.id == 25
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1694165719/cdap-course_jqiywl.jpg'
                            : el.id === 31
                            ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1697707297/81cfccb5-8acc-4962-b8c4-218caf9f9e2a_adh7id.jpg'
                            : ''
                        }
                        alt=''
                      />
                      <div className='topic-card__body'>
                        <h4>{el?.title}</h4>
                        <p>{el.description}</p>

                        <div className='topic-card__count '>
                          <svg
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <g clip-path='url(#clip0_4398_26197)'>
                              <path
                                d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                                fill='#5A5955'
                              />
                              <path
                                d='M9.33366 11.3346H4.66699V10.0013H9.33366V11.3346ZM11.3337 8.66797H4.66699V7.33464H11.3337V8.66797ZM11.3337 6.0013H4.66699V4.66797H11.3337V6.0013Z'
                                fill='#5A5955'
                              />
                            </g>
                            <defs>
                              <clipPath id='clip0_4398_26197'>
                                <rect width='16' height='16' fill='white' />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>{el.lessons_count} Lessons</p>
                          <p>{el.activity_count} Activities</p>
                        </div>
                        <Button
                          className={'orange-border'}
                          text='View Lesson'
                          width={'100%'}
                          onClick={() =>
                            navigate(
                              `/learn/${courseId}/${schoolId}?topic=${id}`
                            )
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Element>

            <Element name='schedules' smooth='true'>
              <div className='learn-about'>
                <h3>Group live class schedule</h3>
                <p>
                  The schedule for the live class are added automatically to
                  your live class page
                </p>

                <div className='learn-about__schedule'>
                  <div className='learn-about__schedule__icon'>
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 16 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g clipPath='url(#clip0_4556_18787)'>
                        <path
                          d='M10 5.33333V10.6667H3.33333V5.33333H10ZM10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4Z'
                          fill='#5A5955'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_4556_18787'>
                          <rect width='16' height='16' fill='white' />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    {content?.live_classes?.map((el) => (
                      <div className='learn-about__schedule__texts'>
                        <h4>
                          {moment(el?.start_date).format('dddd MMMM Do, YYYY')}{' '}
                          - {moment(el?.end_date).format('dddd MMMM Do, YYYY')}
                        </h4>
                        {el?.schedules?.map((item) => (
                          <>
                            <div className='learn-about__schedule__texts__item'>
                              <p>{`${item?.day}s`}</p>
                              <svg
                                width='4'
                                height='4'
                                viewBox='0 0 4 4'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                              </svg>
                              <p>
                                {convertTime(item.start_time)} -{' '}
                                {convertTime(item.end_time)}
                              </p>
                            </div>
                          </>
                        ))}
                      </div>
                    ))}
                    <Button
                      className={'primary-btn'}
                      text={'See Live Classes'}
                      onClick={() => navigate('/profile?classes=live')}
                    />
                  </div>
                </div>
              </div>
            </Element>
            <div className='mobile-content'>
              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='34'
                    height='34'
                    viewBox='0 0 34 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Duration</h3>
                  <p>Estimated {content?.duration} to complete</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='40'
                    height='41'
                    viewBox='0 0 40 41'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_1750_8431)'>
                      <path
                        d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                        fill='#5A5955'
                      />
                      <path
                        d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                        fill='#5A5955'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_1750_8431'>
                        <rect width='40' height='40.9796' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Lessons</h3>
                  <p>{content?.topics_count} Lessons</p>
                </div>
              </div>

              <div className='content-details__item'>
                <div className='content-details__item__icon-wrapper'>
                  <svg
                    width='34'
                    height='34'
                    viewBox='0 0 34 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM28.533 10.3335H23.6163C23.083 8.25016 22.3163 6.25016 21.3163 4.40016C24.383 5.45016 26.933 7.5835 28.533 10.3335ZM16.9997 3.7335C18.383 5.7335 19.4663 7.95016 20.183 10.3335H13.8163C14.533 7.95016 15.6163 5.7335 16.9997 3.7335ZM4.09967 20.3335C3.83301 19.2668 3.66634 18.1502 3.66634 17.0002C3.66634 15.8502 3.83301 14.7335 4.09967 13.6668H9.73301C9.59967 14.7668 9.49967 15.8668 9.49967 17.0002C9.49967 18.1335 9.59967 19.2335 9.73301 20.3335H4.09967ZM5.46634 23.6668H10.383C10.9163 25.7502 11.683 27.7502 12.683 29.6002C9.61634 28.5502 7.06634 26.4335 5.46634 23.6668ZM10.383 10.3335H5.46634C7.06634 7.56683 9.61634 5.45016 12.683 4.40016C11.683 6.25016 10.9163 8.25016 10.383 10.3335ZM16.9997 30.2668C15.6163 28.2668 14.533 26.0502 13.8163 23.6668H20.183C19.4663 26.0502 18.383 28.2668 16.9997 30.2668ZM20.8997 20.3335H13.0997C12.9497 19.2335 12.833 18.1335 12.833 17.0002C12.833 15.8668 12.9497 14.7502 13.0997 13.6668H20.8997C21.0497 14.7502 21.1663 15.8668 21.1663 17.0002C21.1663 18.1335 21.0497 19.2335 20.8997 20.3335ZM21.3163 29.6002C22.3163 27.7502 23.083 25.7502 23.6163 23.6668H28.533C26.933 26.4168 24.383 28.5502 21.3163 29.6002ZM24.2663 20.3335C24.3997 19.2335 24.4997 18.1335 24.4997 17.0002C24.4997 15.8668 24.3997 14.7668 24.2663 13.6668H29.8997C30.1663 14.7335 30.333 15.8502 30.333 17.0002C30.333 18.1502 30.1663 19.2668 29.8997 20.3335H24.2663Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='content-details__item__text'>
                  <h3>Language</h3>
                  <p>{content?.language || 'English '}</p>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '25px',
                }}
              ></div>
            </div>

            <Element name='instructor' smooth='true'>
              <div className='learn-about instructor'>
                <h3>Instructor</h3>
                <div className='instructor__details'>
                  <div className='instructor__details__image'>
                    <img src={school.logo || picture} alt={school.name} />
                  </div>
                  <div className='instructor__details__info'>
                    <h4>{school.name}</h4>
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        marginBottom: '16px',
                      }}
                    >
                      <Place />
                      {school?.state ? (
                        <p style={{ margin: '0' }}>
                          {`${school?.state},${
                            school?.country ? school?.country : 'Nigeria'
                          }`}
                        </p>
                      ) : (
                        <p style={{ margin: '0' }}>Lagos,Nigeria</p>
                      )}
                    </div>
                    <p style={{ marginBottom: '8px' }}>{school?.bio}</p>

                    <p
                      className='learn-about__more'
                      onClick={() => navigate(`/schools/${school?.id}`)}
                    >
                      Read More On School Profile
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.66656 4L5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4Z'
                          fill='#FEA82F'
                        />
                      </svg>
                    </p>
                  </div>
                </div>
              </div>
            </Element>
          </div>
        </div>
      )}
      <div className='texture-bg'>
        <div className='cta'>
          <div className='cta__left'>
            <h1>
              Your academic subject weakness can become an area of strength
            </h1>
            <p>
              Be the first to know when we go live, register on PL by Edves and{' '}
              <br /> become academic stars
            </p>
          </div>
          <div className='cta__right'>
            <Button className='secondary-button' text='Be The First To Know' />
          </div>
        </div>
      </div>

      <Footer />
      <Modal
        width={606}
        visible={showPreview}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <p>Subject introductory preview</p>
          <h2>{content?.subject_class?.title}</h2>
          <div className='teaser-wrap'>
            <video controls>
              <source src={content?.teaser} type='video/mp4' />
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SinglePaidCourse;
